import React, { Component } from "react";
import {
  Button,
  Table,
  Switch,
  Divider,
  Input,
  Cascader,
  Select,
  Icon,
  Modal,
  Form,
  Row,
  Upload,
  Col,
  message,
  AutoComplete
} from "antd";
import {
  _imageUpload,
  _franchiseeList,
  _siteRepairList,
  _deleteSiteRepair,
  _batchDelSiteRepair,
  _updateSiteRepairStatus,
  _siteRepairDetail,
  _getSonsOfRegion,
  _saveSiteRepairInfo,
  _mapGD,
} from "@/statics/js/api";
import { getJurisdiction } from "@/statics/js/jurisdiction";
import { Map, Marker } from "react-amap";
import moment from "moment";

const amapkey = "4792ad0f37a527c1535e83599762d894";

const { Option } = Select;
const modalTitle = ["添加退车点", "编辑退车点", "退车点详情"];
class SiteRepairManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 10, // 每页展示个数
      curPage: 1, //当前页数
      totalCount: 0, //数据总数量
      siteRepairList: [], //退车点列表
      franchiseeList: [], //代理商列表
      queryFormValues: {}, //筛选项
      modalType: "", //1-添加，2-编辑，3-查看
      visible: false, //Modal是否打开
      initialValues: {}, //退车点详情
      options: [], //地区
      id: "", //退车点id
      selectedRowKeys: [], // Check here to configure the default column
      loading: false,
      fileList: [], //上传格式
      addressName: "", //定位时的地址（地图地址）
      mapCenter: { longitude: 0, latitude: 0 },
      markerPosition: { longitude: 0, latitude: 0 },
      autoList: [],
    };
    this.columns = [
      {
        title: "序号",
        dataIndex: "no",
        width: 80,
        render: (text, record, index) =>
          this.state.pageSize * (this.state.curPage - 1) + index + 1,
      },
      {
        title: "退车点名称",
        dataIndex: "name",
      },
      {
        title: "所属代理商",
        dataIndex: "fname",
      },
      {
        title: "联系人",
        width: 100,
        dataIndex: "contacts",
      },
      {
        title: "联系电话",
        align: "right",
        width: 150,
        dataIndex: "tel",
      },
      {
        title: "城市",
        width: 100,
        dataIndex: "cityName",
      },
      {
        title: "地址",
        dataIndex: "address",
      },
      {
        title: "添加时间",
        width: 120,
        dataIndex: "addTime",
        render: (text) => text && moment(text).format("YYYY-MM-DD HH:mm:ss"),
      },
      {
        title: "备注",
        dataIndex: "remark",
      },
      {
        title: "管理状态",
        width: 100,
        dataIndex: "",
        render: (text) => (
          <Switch
            disabled={!getJurisdiction(880)}
            title={getJurisdiction(880) ? "" : "暂无操作权限！"}
            defaultChecked={!!text.state}
            checkedChildren="启用"
            unCheckedChildren="禁用"
            onChange={this.handleStateChange.bind(this, text.id)}
          />
        ),
      },
      {
        title: "操作",
        dataIndex: "",
        key: "Action",
        width: 100,
        fixed: "right",
        render: (text) => (
          <span>
            <Button
              type="link"
              disabled={!getJurisdiction(877)}
              title={getJurisdiction(877) ? "" : "暂无操作权限！"}
              onClick={this.getSiteDetail.bind(this, text.id, 3)}
            >
              查看
            </Button>
            <Divider type="vertical" />
            <Button
              type="link"
              disabled={!getJurisdiction(875)}
              title={getJurisdiction(875) ? "" : "暂无操作权限！"}
              onClick={this.getSiteDetail.bind(this, text.id, 2)}
            >
              编辑
            </Button>
            <Divider type="vertical" />
            <Button
              type="link"
              disabled={!getJurisdiction(879)}
              title={getJurisdiction(879) ? "" : "暂无操作权限！"}
              onClick={this.handleDeleteSiteChange.bind(this, text.id)}
            >
              删除
            </Button>
          </span>
        ),
      },
    ];
  }

  // 筛选表头
  renderForm() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row gutter={16}>
          <Col lg={6} md={12} sm={24}>
            <Form.Item label="退车点名称">
              {getFieldDecorator("nameSearch")(
                <Input allowClear placeholder="请输入" />
              )}
            </Form.Item>
          </Col>
          <Col lg={6} md={12} sm={24}>
            <Form.Item label="城市">
              {getFieldDecorator("areaList")(
                <Cascader
                  options={this.state.options}
                  loadData={this.getLoadData.bind(this)}
                  changeOnSelect
                />
              )}
            </Form.Item>
          </Col>
          <Col lg={6} md={12} sm={24}>
            <Form.Item label="代理商">
              {getFieldDecorator("fidSearch")(
                <Select
                  placeholder="请选择"
                  allowClear
                  style={{ width: "100%" }}
                  showSearch
                  filterOption={(input, option) => {
                    return (
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }}
                >
                  {this.state.franchiseeList.length &&
                    this.state.franchiseeList.map((item, index) => {
                      return (
                        <Option key={index} value={item.fid}>
                          {item.fname}
                        </Option>
                      );
                    })}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col lg={6} md={12} sm={24}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                搜索
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }

  render() {
    const {
      loading,
      selectedRowKeys,
      fileList,
      totalCount,
      curPage,
      pageSize,
      siteRepairList,
      initialValues,
      autoList,
    } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const hasSelected = selectedRowKeys.length > 0;
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        {getJurisdiction(874) ? (
          <div className="SiteRepairManagement">
            <div className="select-form">{this.renderForm()}</div>
            <div className="top-btn">
              <Button
                icon="plus"
                type="primary"
                onClick={this.showModal.bind(this, 1)}
                disabled={!getJurisdiction(876)}
                title={getJurisdiction(876) ? "" : "暂无操作权限！"}
              >
                添加退车点
              </Button>
              <Button
                onClick={this.handleBatchDeleteChange.bind(this)}
                disabled={!hasSelected}
                loading={loading}
                icon="delete"
                type="danger"
              >
                批量删除
              </Button>
              {hasSelected && `已选中 ${selectedRowKeys.length} 项`}
            </div>
            <div className="content-table">
              <Table
                rowKey="id"
                bordered
                rowSelection={rowSelection}
                columns={this.columns}
                dataSource={siteRepairList}
                scroll={{ x: 1600, y: 500 }}
                pagination={{
                  showQuickJumper: true,
                  defaultPageSize: pageSize,
                  showSizeChanger: true,
                  onShowSizeChange: this.handlePageChange.bind(this),
                  onChange: this.handlePageChange.bind(this),
                  total: totalCount,
                  current: curPage,
                  showTotal: (totalCount) => `总共 ${totalCount} 条记录`,
                }}
              />
            </div>
            <Modal
              className="bigModal"
              title={modalTitle[this.state.modalType - 1]}
              destroyOnClose
              maskClosable={false}
              visible={this.state.visible}
              onOk={this.handleOk.bind(this)}
              onCancel={this.initFormModal.bind(this)}
            >
              <Row>
                <Col span={24}>
                  <Form.Item label="代理商">
                    {this.state.modalType === 3 ? (
                      <span>{initialValues.fname}</span>
                    ) : (
                      getFieldDecorator("fid", {
                        initialValue: initialValues.fid,
                        rules: [{ required: true, message: "请选择代理商！" }],
                      })(
                        <Select
                          placeholder="请选择"
                          allowClear
                          style={{ width: "100%" }}
                          showSearch
                          filterOption={(input, option) => {
                            return (
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                        >
                          {this.state.franchiseeList.length &&
                            this.state.franchiseeList.map((item, index) => {
                              return (
                                <Option key={index} value={item.fid}>
                                  {item.fname}
                                </Option>
                              );
                            })}
                        </Select>
                      )
                    )}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="退车点名称">
                    {this.state.modalType === 3 ? (
                      <span>{initialValues.name}</span>
                    ) : (
                      getFieldDecorator("name", {
                        initialValue: initialValues.name,
                        rules: [
                          { required: true, message: "请输入退车点名称！" },
                        ],
                      })(<Input allowClear placeholder="请输入" />)
                    )}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="退车点图片">
                    {getFieldDecorator("img", {
                      initialValue: initialValues.img || undefined,
                      getValueFromEvent: this.normFile,
                    })(
                      <Upload
                        disabled={this.state.modalType === 3 ? true : false}
                        name="uploadFile"
                        action={_imageUpload}
                        listType="picture-card"
                        fileList={fileList}
                        accept="image/jpg,image/jpeg,image/png,image/gif"
                        onChange={this.handleChange.bind(this)}
                        data={{
                          scene: "active",
                        }}
                      >
                        {fileList.length >= 1 ? null : (
                          <div>
                            <Icon type="plus" style={{ fontSize: "28px" }} />
                            <p>退车点图片上传</p>
                          </div>
                        )}
                      </Upload>
                    )}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="退车点联系人">
                    {this.state.modalType === 3 ? (
                      <span>{initialValues.contacts}</span>
                    ) : (
                      getFieldDecorator("contacts", {
                        initialValue: initialValues.contacts,
                        rules: [
                          { required: true, message: "请输入退车点联系人！" },
                        ],
                      })(<Input allowClear placeholder="请输入" />)
                    )}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="联系人电话">
                    {this.state.modalType === 3 ? (
                      <span>{initialValues.tel}</span>
                    ) : (
                      getFieldDecorator("tel", {
                        validateTrigger: "onBlur",
                        rules: [
                          {
                            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
                            message: "请输入正确的手机号格式",
                          },
                          { required: true, message: "请输入联系人电话！" },
                        ],
                        initialValue: initialValues.tel,
                      })(<Input allowClear placeholder="请输入" />)
                    )}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="地区">
                    {this.state.modalType === 3 ? (
                      <span>{initialValues.areaName}</span>
                    ) : (
                      getFieldDecorator("areaList", {
                        rules: [
                          {
                            required: this.state.modalType === 1 ? true : false,
                            message: "请选择地区！",
                          },
                        ],
                      })(
                        <Cascader
                          placeholder={
                            initialValues.areaName && initialValues.areaName
                          }
                          style={{ width: "100%" }}
                          options={this.state.options}
                          loadData={this.getLoadData.bind(this)}
                          changeOnSelect
                        />
                      )
                    )}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="详情地址">
                    {this.state.modalType === 3 ? (
                      <span>{initialValues.address}</span>
                    ) : (
                      getFieldDecorator("address", {
                        initialValue: initialValues.address,
                        rules: [
                          { required: true, message: "请输入详情地址！" },
                        ],
                      })(<Input allowClear placeholder="请输入" />)
                    )}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="备注">
                    {this.state.modalType === 3 ? (
                      <span>{initialValues.remark}</span>
                    ) : (
                      getFieldDecorator("remark", {
                        initialValue: initialValues.remark,
                      })(<Input allowClear placeholder="请输入" />)
                    )}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="坐标">
                    {this.state.modalType === 3 ? (
                      <span>{initialValues.coordinate}</span>
                    ) : (
                      getFieldDecorator("coordinate", {
                        initialValue: initialValues.coordinate,
                        rules: [{ required: true, message: "请选择坐标！" }],
                      })(
                        <div>
                          <Input
                            disabled
                            value={
                              this.state.markerPosition.longitude +
                              "，" +
                              this.state.markerPosition.latitude
                            }
                          />
                          <p className="top_map_p">
                            当前地址：
                            {this.state.addressName}
                          </p>
                          <div style={{ width: "100%", height: 300 }}>
                            <Map
                              amapkey={amapkey}
                              zoom={8}
                              events={{
                                click: (e) => {
                                  this.setState({
                                    markerPosition: {
                                      longitude: e.lnglat.getLng(),
                                      latitude: e.lnglat.getLat(),
                                    },
                                  });
                                  this.handleClickAmapChange(
                                    e.lnglat.getLng(),
                                    e.lnglat.getLat()
                                  );
                                },
                              }}
                              center={this.state.mapCenter}
                            >
                              <Marker position={this.state.markerPosition} />
                              <AutoComplete
                                style={{ width: 300, position: 'absolute', left: '10px', top: '10px'}}
                                placeholder="搜索"
                                optionLabelProp="value"
                                dataSource={
                                  autoList.map((item,index)=>(
                                    <AutoComplete.Option key={index} value={item.name} position={item.location}>
                                      {item.name}
                                      <span style={{color: 'rgba(0, 0, 0, 0.3)'}}>{item.district}</span>
                                    </AutoComplete.Option>
                                  ))
                                }
                                onSelect={(value,option)=>{
                                  const {position={}} = option.props
                                  this.setState({
                                    mapCenter: {
                                      longitude: position.lng,
                                      latitude: position.lat,
                                    },
                                    markerPosition: {
                                      longitude: position.lng,
                                      latitude: position.lat,
                                    },
                                  });
                                  this.handleClickAmapChange(
                                    position.lng,
                                    position.lat
                                  );
                                }}
                                onSearch={async (keywords)=>{
                                  window.AMap.plugin('AMap.Autocomplete',async ()=>{
                                    let autoComplete = await new window.AMap.Autocomplete({city: '全国'})
                                    autoComplete.search(keywords, (status, result)=> {
                                      if(status == 'complete'){
                                        let {tips=[]} = result || {}
                                        tips = tips.filter(item=>item.location)
                                        this.setState({autoList: tips || []})
                                      }else{
                                        this.setState({autoList: []})
                                      }
                                    })
                                  })
                                }}
                              />
                            </Map>
                          </div>
                        </div>
                      )
                    )}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="管理状态">
                    {getFieldDecorator("state", {
                      initialValue: initialValues.state === 0 ? false : true,
                      valuePropName: "checked",
                    })(
                      <Switch
                        disabled={this.state.modalType === 3 && true}
                        checkedChildren="启用"
                        unCheckedChildren="禁用"
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </Modal>
          </div>
        ) : (
          "暂无操作权限！"
        )}
      </div>
    );
  }
  componentDidMount() {
    this.getFranchiseeList();
    this.getSiteRepairList(
      this.state.curPage,
      this.state.pageSize,
      this.state.queryFormValues
    );
    this.getSonsOfRegion(0);
  }

  //获取代理商列表
  getFranchiseeList() {
    let params = {
      curPage: 1,
      pageSize: 999,
    };
    _franchiseeList(params)
      .then((res) => {
        if (res.data.code === 200) {
          if (!res.data.data.rows.length) {
            message.warning("暂无数据！");
          }
          this.setState({
            franchiseeList: res.data.data.rows,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //获取坐标的详细地址
  handleClickAmapChange(longitude, latitude) {
    let location = longitude + "," + latitude;
    let params = {
      output: "json",
      location: location,
      key: "1607b8afa5a91ccba6d84b8cd4cd5a24",
      radius: 1000,
      extensions: "base",
    };
    _mapGD({ params: params })
      .then((res) => {
        this.setState({
          addressName: res.data.regeocode.formatted_address,
          province: res.data.regeocode.addressComponent.province,
          city: res.data.regeocode.addressComponent.city,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //获取退车点列表
  getSiteRepairList(curPage, pageSize, queryFormValues) {
    let params = {
      ...queryFormValues,
      curPage: curPage,
      pageSize: pageSize,
    };
    _siteRepairList(params)
      .then((res) => {
        if (res.data.code === 200) {
          if (!res.data.data.rows.length) {
            message.warning("暂无数据！");
          }
          this.setState({
            siteRepairList: res.data.data.rows,
            totalCount: res.data.data.totalCount,
            curPage: curPage,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //分页
  handlePageChange(curPage, pageSize) {
    this.getSiteRepairList(curPage, pageSize, this.state.queryFormValues);
  }

  //updata start
  handleChange = ({ file, fileList }) => {
    if (fileList.length === 1) {
      if (!!fileList[0].response) {
        if (fileList[0].response.code !== 200) {
          message.warning(fileList[0].response.message);
          fileList.splice(0, 1);
        }
      }
    }
    this.updateFileList(fileList);
  };
  updateFileList = (fileList) => {
    this.setState({
      fileList,
    });
  };
  normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  //单条删除
  handleDeleteSiteChange(id) {
    Modal.confirm({
      title: "删除信息",
      content: "是否确定删除此数据？",
      onOk() {
        let params = { id };
        _deleteSiteRepair(params).then((res) => {
          if (res.data.code === 200) {
            message.success("操作成功");
            setTimeout(function () {
              window.location.reload();
            }, 1000);
          }
        });
      },
    });
  }

  //批量删除
  handleBatchDeleteChange() {
    let self = this;
    self.setState({ loading: true });
    Modal.confirm({
      title: "删除信息",
      content: "是否确定批量删除数据吗？",
      onOk() {
        let params = self.state.selectedRowKeys;
        _batchDelSiteRepair(params)
          .then((res) => {
            if (res.data.code === 200) {
              message.success("操作成功");
              setTimeout(function () {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((err) => {
            console.log(err);
            message.warning("操作失败");
            setTimeout(() => {
              self.setState({
                selectedRowKeys: [],
                loading: false,
              });
            }, 1000);
          });
      },
    });
  }

  //管理状态Switch
  handleStateChange(id, checked) {
    let params = { id, state: Number(checked) };
    _updateSiteRepairStatus(params)
      .then((res) => {
        if (res.data.code === 200) {
          message.success("操作成功");
          this.getSiteRepairList(
            this.state.curPage,
            this.state.pageSize,
            this.state.queryFormValues
          );
        } else {
          message.warning(res.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //选中数据
  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  // 表单筛选
  handleSubmit = (e) => {
    e.preventDefault();
    const { form } = this.props;
    form.validateFields((err, values) => {
      // if (err) return;
      for (let key in values) {
        if (
          values[key] === undefined ||
          values[key] === null ||
          values[key] === ""
        ) {
          delete values[key];
        }
      }
      delete values.state;
      if (values.nameSearch) {
        values.name = values.nameSearch;
        delete values.nameSearch;
      }
      if (values.fidSearch) {
        values.fid = values.fidSearch;
        delete values.fidSearch;
      }
      let province, city, county, street;
      if (values.areaList) {
        province = values.areaList[0] ? values.areaList[0] : null;
        city = values.areaList[1] ? values.areaList[1] : null;
        county = values.areaList[2] ? values.areaList[2] : null;
        street = values.areaList[3] ? values.areaList[3] : null;
        values.province = province;
        values.city = city;
        values.county = county;
        values.street = street;
        delete values.areaList;
      }
      this.setState({
        queryFormValues: values,
      });
      this.getSiteRepairList(1, this.state.pageSize, values);
    });
  };

  //获取工地详情
  getSiteDetail(id, type) {
    let params = { id };
    _siteRepairDetail(params)
      .then((res) => {
        if (res.data.code === 200) {
          let longitude, latitude;
          let coordinate = res.data.data.coordinate;
          longitude = coordinate ? coordinate.split(",")[0] : 0;
          latitude = coordinate ? coordinate.split(",")[1] : 0;
          this.setState({
            id,
            initialValues: res.data.data,
            mapCenter: { longitude, latitude },
            markerPosition: { longitude, latitude },
          });
          res.data.data.imgObject &&
            this.updateFileList([
              {
                uid: -1,
                name: res.data.data.imgObject.id,
                status: "done",
                url: res.data.data.imgObject.path,
              },
            ]);
          this.showModal(type);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //加载地区数据
  getLoadData(selectedOptions) {
    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;
    // load options lazily
    let params = { parentid: targetOption.value };
    _getSonsOfRegion(params)
      .then((res) => {
        if (res.data.code === 200) {
          let areaList = res.data.data;
          if (areaList instanceof Array) {
            areaList = areaList.map((item, index) => {
              return {
                label: item.name,
                value: +item.areaid,
                isLeaf: !item.hasChild,
              };
            });
          } else {
            areaList = [];
          }
          targetOption.children = areaList;
          targetOption.loading = false;
          let options = [...this.state.options];
          this.setState({
            options,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //获取一级地区
  getSonsOfRegion(parentid) {
    let params = { parentid };
    _getSonsOfRegion(params)
      .then((res) => {
        if (res.data.code === 200) {
          let areaList = res.data.data;
          if (areaList instanceof Array) {
            areaList = areaList.map((item, index) => {
              return {
                label: item.name,
                value: +item.areaid,
                isLeaf: !item.hasChild,
              };
            });
          } else {
            areaList = [];
          }
          this.setState({
            options: [...areaList],
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //Modal打开事件
  showModal(modalType) {
    this.props.form && this.props.form.resetFields();
    this.setState({
      options: [],
      modalType,
      visible: true,
    });
    this.getSonsOfRegion(0);
  }

  //Modal提交事件
  handleOk(e) {
    e.preventDefault();
    const { form } = this.props;
    const { modalType, id } = this.state;
    form.validateFields((err, values) => {
      if (err) return;
      for (let key in values) {
        if (
          values[key] === undefined ||
          values[key] === null ||
          values[key] === ""
        ) {
          delete values[key];
        }
      }
      if (values.img && values.img.constructor === Array) {
        values.img =
          values.img.length === 1 ? values.img[0].response.data.id : "";
      }
      if (values.state !== undefined) {
        values.state = Number(values.state);
      }
      // values.state === undefined && modalType === 1
      //   ? (values.state = 1)
      //   : !!values.state
      //   ? (values.state = 1)
      //   : (values.state = 0);
      if (values.areaList) {
        values.province = values.areaList[0] ? values.areaList[0] : null;
        values.city = values.areaList[1] ? values.areaList[1] : null;
        values.county = values.areaList[2] ? values.areaList[2] : null;
        values.street = values.areaList[3] ? values.areaList[3] : null;
        delete values.areaList;
      }
      if (
        this.state.markerPosition.longitude &&
        this.state.markerPosition.latitude
      ) {
        values.coordinate =
          this.state.markerPosition.longitude +
          "," +
          this.state.markerPosition.latitude;
      }
      if (modalType === 3) {
        this.setState({
          visible: false,
        });
      } else {
        let params =
          modalType === 1
            ? { ...values }
            : modalType === 2
            ? {
                id,
                ...values,
              }
            : {};
        _saveSiteRepairInfo(params)
          .then((res) => {
            if (res.data.code === 200) {
              message.success("操作成功");
              this.setState({
                visible: false,
              });
              setTimeout(function () {
                window.location.reload();
              }, 1000);
            } else {
              message.warning(res.data.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }

  //Modal取消事件
  initFormModal() {
    this.props.form && this.props.form.resetFields();
    this.updateFileList([]);
    this.setState({
      id: "",
      initialValues: {},
      modalType: null,
      options: [],
      visible: false,
      mapCenter: { longitude: 0, latitude: 0 },
      markerPosition: { longitude: 0, latitude: 0 },
    });
    this.getSonsOfRegion(0);
  }
}

SiteRepairManagement = Form.create({})(SiteRepairManagement);
export { SiteRepairManagement };
